import { create } from 'zustand';

import { type DocumentTitleEntry } from '~/components/v2/store/features/document-title/getActiveDocumentTitle';

export type DocumentTitleState = {
  entries: DocumentTitleEntry[];
  setEntry: (entry: DocumentTitleEntry) => void;
  removeEntry: (id: DocumentTitleEntry['id']) => void;
};

export const useDocumentTitleStore = create<DocumentTitleState>()((set) => ({
  entries: [],
  setEntry: (entry) =>
    set(({ entries }) => {
      const index = entries.findIndex(({ id }) => id === entry.id);

      if (index === -1) {
        return { entries: [...entries, entry] };
      }

      const nextEntries = [...entries];
      nextEntries[index] = entry;

      return { entries: nextEntries };
    }),
  removeEntry: (id) => set(({ entries }) => ({ entries: entries.filter((entry) => entry.id !== id) })),
}));
